export default "__VITE_ASSET___n3vxQ0A__"